import { useMemo } from 'react'

// needle: string || string[], haystack = string[]
const useCheckSomeInArray = (needles, haystack = []) =>
  useMemo(() => {
    if (typeof needles === 'string') {
      if (haystack.length === 0) {
        return false
      }

      return haystack?.includes(needles)
    }

    return needles.some((needle) => haystack?.includes(needle))
  }, [needles, haystack])

export default useCheckSomeInArray
